<template>
  <header class="topbar">
    <button
      type="button"
      class="icon-btn -ml-2"
      title="Menu"
      aria-label="Buka atau sematkan menu"
      @click="toggleMenu"
    >
      <font-awesome-icon :icon="['fas', 'bars']" />
    </button>

    <div class="min-w-0 leading-tight">
      <p
        class="truncate text-[11px] font-medium uppercase tracking-[0.08em] text-gray-400"
      >
        {{ current.group }}
      </p>
      <h1 class="truncate text-sm font-semibold text-gray-900 dark:text-white">
        {{ current.label }}
      </h1>
    </div>

    <div class="ml-auto flex items-center gap-2">
      <button
        type="button"
        class="icon-btn"
        :title="theme.isDark ? 'Mode terang' : 'Mode gelap'"
        :aria-label="theme.isDark ? 'Mode terang' : 'Mode gelap'"
        @click="toggleDark"
      >
        <font-awesome-icon :icon="['fas', theme.isDark ? 'sun' : 'moon']" />
      </button>

      <div ref="userMenu" class="relative">
        <button
          type="button"
          class="flex items-center gap-2.5 rounded-xl py-1 pl-1 pr-2 transition-colors hover:bg-gray-100 dark:hover:bg-gray-800"
          :aria-expanded="menuOpen"
          aria-haspopup="menu"
          @click="menuOpen = !menuOpen"
        >
          <span
            class="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-600 text-xs font-semibold uppercase text-white"
          >
            {{ initialName }}
          </span>
          <span
            class="hidden max-w-[10rem] truncate text-sm font-medium text-gray-700 dark:text-gray-200 md:block"
          >
            {{ userFullName }}
          </span>
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="text-[10px] text-gray-400"
          />
        </button>

        <div v-if="menuOpen" class="user-menu" role="menu">
          <div
            class="border-b border-gray-100 px-4 py-3 dark:border-gray-800"
            role="none"
          >
            <p
              class="truncate text-sm font-medium text-gray-900 dark:text-white"
            >
              {{ userFullName }}
            </p>
            <p class="truncate text-xs text-gray-500 dark:text-gray-400">
              {{ userName }}
            </p>
          </div>
          <router-link
            to="/profil"
            class="user-menu-item"
            role="menuitem"
            @click="menuOpen = false"
          >
            <font-awesome-icon :icon="['fas', 'user']" class="w-4" />
            Profil
          </router-link>
          <button
            type="button"
            class="user-menu-item"
            role="menuitem"
            @click="logout()"
          >
            <font-awesome-icon
              :icon="['fas', 'right-from-bracket']"
              class="w-4"
            />
            Keluar
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Swal from "sweetalert2";
import userData from "../plugins/userData";
import { theme, toggleDark, toggleSidebarPin } from "../plugins/theme";
import { findCurrent } from "../plugins/menu";

export default {
  name: "UserBar",
  mixins: [userData],
  data() {
    return {
      theme,
      menuOpen: false,
    };
  },
  computed: {
    current() {
      return findCurrent(this.$route.path);
    },
    initialName() {
      return (this.userFullName || "").substring(0, 2);
    },
  },
  mounted() {
    document.addEventListener("click", this.closeOnOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeOnOutsideClick);
  },
  methods: {
    toggleDark,
    // Layar sempit: buka laci menu. Layar lebar: sematkan/ciutkan sidebar.
    toggleMenu() {
      if (window.matchMedia("(max-width: 639px)").matches) {
        this.theme.sidebarMobileOpen = !this.theme.sidebarMobileOpen;
      } else {
        toggleSidebarPin();
      }
    },
    closeOnOutsideClick(event) {
      const menu = this.$refs.userMenu;
      if (menu && !menu.contains(event.target)) this.menuOpen = false;
    },
    logout() {
      this.menuOpen = false;
      Swal.fire({
        title: "",
        text: "Apakah Anda Akan Logout ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Logout!",
      }).then((result) => {
        if (result.value) {
          localStorage.removeItem("userData");
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        }
      });
    },
  },
};
</script>
